var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("h1", { staticClass: "subtitle is-5" }, [
      _vm._v("\n    Administrar usuario\n  "),
    ]),
    _vm._v(" "),
    _c("h1", { staticClass: "title is-2" }, [_vm._v("Cambiar contraseña")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-6-desktop is-8-tablet" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Nueva contraseña")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.forcePassword,
                  expression: "forcePassword",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|min:6",
                  expression: "'required|min:6'",
                },
              ],
              ref: "force_password",
              staticClass: "input",
              attrs: {
                placeholder: "Contraseña",
                name: "force_password",
                type: "password",
                "data-vv-name": "force_password",
                "data-vv-as": "Nueva contraseña",
              },
              domProps: { value: _vm.forcePassword },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.forcePassword = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("force_password"),
                    expression: "errors.has('force_password')",
                  },
                ],
                staticClass: "help is-danger",
              },
              [_vm._v(_vm._s(_vm.errors.first("force_password")))]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Repetir contraseña")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.repeatForcePassword,
                  expression: "repeatForcePassword",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|confirmed:force_password",
                  expression: "'required|confirmed:force_password'",
                },
              ],
              staticClass: "input",
              attrs: {
                placeholder: "Re-escriba la password",
                type: "password",
                "data-vv-name": "force_password_confirmation",
                "data-vv-as": "Repetir contraseña",
              },
              domProps: { value: _vm.repeatForcePassword },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.repeatForcePassword = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("force_password_confirmation"),
                    expression: "errors.has('force_password_confirmation')",
                  },
                ],
                staticClass: "help is-danger",
              },
              [_vm._v(_vm._s(_vm.errors.first("force_password_confirmation")))]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "buttons is-right" }, [
      _c(
        "button",
        {
          staticClass: "button is-primary",
          attrs: { disabled: _vm.errors.any() || !_vm.repeatForcePassword },
          on: {
            click: function ($event) {
              return _vm.resetPassword()
            },
          },
        },
        [_vm._v("\n      Guardar\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n    Puede forzar una nueva contraseña al usuario. Requiere ser\n    "
      ),
      _c("span", { staticClass: "tag is-success is-rounded" }, [
        _vm._v("Lyris"),
      ]),
      _vm._v(" o\n    "),
      _c("span", { staticClass: "tag is-info is-rounded" }, [
        _vm._v("Lyris Soporte"),
      ]),
      _vm._v(".\n  "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }